import { notification } from 'antd';
import { call, debounce, put } from 'redux-saga/effects';

import { DEFAULT_DEBOUNCE_DELAY } from '#constants';
import CryptoWalletService from '#services/CryptoWalletService';

import { getCryptoWallets, setCryptoWallets, setLoading } from './';

function* getCryptoWalletsList(data) {
  try {
    yield put(setLoading(true));
    const wallets = yield call(CryptoWalletService.getList, data?.payload);
    yield put(setCryptoWallets(wallets));
  } catch (error) {
    notification.error({ message: error?.response?.data?.error?.message });
    yield put(setLoading(false));
    yield put(setCryptoWallets({ count: 0, result: [] }));
  }
}

function* CryptoWalletsSaga() {
  yield debounce(
    DEFAULT_DEBOUNCE_DELAY,
    getCryptoWallets.type,
    getCryptoWalletsList
  );
}

export default CryptoWalletsSaga;
